import React, { useState } from "react";
import {
  Navbar as BootstrapNavbar,
  Nav,
  Container,
  Button,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackPhoneClick, trackAppointmentClick } from "../utils/analytics";
// import { LinkContainer } from "react-router-bootstrap";
// import { useOdoroModal } from "../contexts/OdoroModalContext";
// import { useLanguage } from "../contexts/LanguageProvider"; // Russian language handling disabled
import "./NavBar.css";

const Navbar: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  // const { language, setLanguage } = useLanguage(); // Russian language handling disabled
  // const { openModal } = useOdoroModal();
  const { t } = useTranslation();

  // reference logo from /public/assets
  // const logo = process.env.PUBLIC_URL + "/assets/logo.png";

  const handleToggle = (nextExpanded: boolean) => setExpanded(nextExpanded);
  const handleNavClick = () => setExpanded(false);

  // const handleLanguageChange = (languageSelection: "hebrew" | "russian") => {
  //   // Map navbar values to LanguageProvider values
  //   const langCode = languageSelection === "hebrew" ? "he" : "ru";
  //   setLanguage(langCode);
  //   // Close the mobile menu automatically after language selection
  //   setExpanded(false);
  // };

  return (
    <BootstrapNavbar
      expand="xl"
      bg="white"
      className="navbar-custom"
      expanded={expanded}
      onToggle={handleToggle}
    >
      <Container className="navbar-rtl-container">
        {/* Brand / Logo */}
        {/* <BootstrapNavbar.Brand
          as={NavLink}
          to="/"
          className="brand text-brand-1 d-flex align-items-center gap-2"
          onClick={handleNavClick}
        >
          <img src={logo} alt="Logo" className="brand-logo" />
          
        </BootstrapNavbar.Brand> */}
        <BootstrapNavbar.Brand
          as={NavLink}
          to="/"
          className="brand text-brand-1 d-flex align-items-center gap-2"
          onClick={handleNavClick}
        >
          {/* במקום תמונת לוגו */}
          <div className="brand-logo">
            <span className="line1" dir="rtl">
              {t("Global.Navbar.nav_brand_title")}
            </span>
            <span className="line2" dir="rtl">
              {t("Global.Navbar.nav_brand_subtitle")}
            </span>
          </div>
        </BootstrapNavbar.Brand>

        {/* Toggle for mobile */}
        <BootstrapNavbar.Toggle
          aria-controls="basic-navbar-nav"
          className="border-0"
        >
          <span className="navbar-toggler-icon"></span>
        </BootstrapNavbar.Toggle>

        <BootstrapNavbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-between"
        >
          {/* Spacer to push main nav to center */}
          {/* <div className="navbar-spacer"></div> */}

          {/* Main links - centered */}
          <Nav
            className="main-nav justify-content-center"
            style={{ marginRight: "3rem" }}
          >
            {/* <Nav.Link
              as={NavLink}
              to="/"
              className="nav-link-custom"
              onClick={handleNavClick}
              end
            >
              בית
            </Nav.Link> */}
            <Nav.Link
              as={NavLink}
              to="/about/"
              className="nav-link-custom"
              onClick={handleNavClick}
            >
              {t("Global.Navbar.nav_about")}
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/conditions/"
              className="nav-link-custom"
              onClick={handleNavClick}
            >
              {t("Global.Navbar.nav_conditions")}
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/services-dr/"
              className="nav-link-custom"
              onClick={handleNavClick}
            >
              {t("Global.Navbar.nav_services")}
            </Nav.Link>
            {/* <Nav.Link
              as={NavLink}
              to="/review/"
              className="nav-link-custom"
              onClick={handleNavClick}
            >
              {t("Global.Navbar.nav_reviews")}
            </Nav.Link> */}
            <Nav.Link
              as={NavLink}
              to="/contact/"
              className="nav-link-custom"
              onClick={handleNavClick}
            >
              {t("Global.Navbar.nav_contact")}
            </Nav.Link>
          </Nav>

          {/* Right side actions */}
          <Nav className="cta-wrap">
            {/* Language Switch disabled: Russian language handling removed */}
            {/**
            <div className="language-switch">
              <span
                className={`language-option ${language === "he" ? "active" : ""}`}
                onClick={() => handleLanguageChange("hebrew")}
              >
                {t("Global.Navbar.nav_language_hebrew")}
              </span>
              <span className="language-divider">|</span>
              <span
                className={`language-option ${language === "ru" ? "active" : ""}`}
                onClick={() => handleLanguageChange("russian")}
              >
                {t("Global.Navbar.nav_language_russian")}
              </span>
            </div>
            */}

            {/* <Nav.Link
              as={NavLink}
              to="/login"
              className="nav-link-custom p-semibold me-3"
              onClick={handleNavClick}
            >
              התחברות
            </Nav.Link> */}

            {/* Appointment Button - Calls Phone Number */}
            <Button
              as="a"
              href={`tel:${t(
                "Contact.ContactDetails.contact_main_clinic_tel_tel"
              )}`}
              className="btn-appointment btn-pill btn-primary-brand"
              onClick={() => {
                handleNavClick();
                trackPhoneClick(
                  t("Contact.ContactDetails.contact_main_clinic_tel_tel")
                );
                trackAppointmentClick("navbar");
              }}
            >
              {t("Global.Navbar.nav_appointment_button")}
            </Button>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar;
